module.exports = __webpack_public_path__ + "static/media/unacceptable-images.7765f338.PNG";